module.exports = __webpack_public_path__ + "assets/img/undraw_random_thoughts_re_cob6.a9919c56.svg";